var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info__area"},[_c('div',{staticClass:"info_layout"},[_c('div',{staticClass:"title_area"},[_c('div',{staticClass:"user__detail mb-10"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }